var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Add",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M32,47.5a1.74,1.74,0,0,1-1.72-1.42,3.64,3.64,0,0,1-.05-.65V33.77H18.44a1.8,1.8,0,0,1-1.67-.86,1.73,1.73,0,0,1-.11-1.62,1.7,1.7,0,0,1,1.27-1,3.64,3.64,0,0,1,.65,0H30.23V18.57A1.89,1.89,0,0,1,31,16.8a1.75,1.75,0,0,1,2.73,1.32c0,.13,0,.26,0,.39V30.23H45.43a1.91,1.91,0,0,1,1.77.8,1.75,1.75,0,0,1-1.32,2.73H33.77s0,8.82,0,11.8a1.8,1.8,0,0,1-.86,1.67A1.7,1.7,0,0,1,32,47.5Z"/>
    <path d="M32,17a1.25,1.25,0,0,1,1.26,1.16c0,.12,0,.23,0,.35V30.73H45.44a1.38,1.38,0,0,1,1.35.58,1.25,1.25,0,0,1-.94,1.95H33.27v3.38q0,4.46,0,8.92a1.29,1.29,0,0,1-.62,1.25A1.19,1.19,0,0,1,32,47a1.24,1.24,0,0,1-1.23-1,3.18,3.18,0,0,1,0-.56V33.27H18.43a1.29,1.29,0,0,1-1.25-.62A1.24,1.24,0,0,1,18,30.78a3.18,3.18,0,0,1,.56,0H30.73V18.57a1.39,1.39,0,0,1,.58-1.35A1.22,1.22,0,0,1,32,17m0-1a2.23,2.23,0,0,0-1.25.38,2.4,2.4,0,0,0-1,2.18q0,5.58,0,11.17H18.57a4.18,4.18,0,0,0-.74.06,2.24,2.24,0,0,0-1.49,3.39,2.29,2.29,0,0,0,2.09,1.09h11.3q0,5.58,0,11.17a4.18,4.18,0,0,0,.06.74A2.24,2.24,0,0,0,32,48a2.19,2.19,0,0,0,1.17-.34,2.29,2.29,0,0,0,1.09-2.1q0-5.65,0-11.3H45.92a2.25,2.25,0,0,0,1.7-3.5,2.4,2.4,0,0,0-2.18-1H34.27q0-5.56,0-11.13c0-.17,0-.35,0-.52A2.26,2.26,0,0,0,32,16Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/add.svg